import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';

// --- Facades ---
import { FavoritesFacade } from '@facades/favorites.facade';
import { ParametersFacade } from '@facades/parameters.facade';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	selector: 'app-favorites-dialog',
	templateUrl: './favorites-dialog.component.html',
	styleUrls: ['./favorites-dialog.component.scss'],
})
export class FavoritesDialogComponent {
	@Output() clickOpenFavoritesEvent = new EventEmitter<void>();

	readonly startSlice = 0;
	readonly endSlice = 3;

	readonly favorites$ = this.favoritesFacade
		.getFavorites({ page: 1, pageLimit: this.endSlice }, true)
		.pipe(tap(() => (this.loading = false)));

	objectFit = this.parameters?.allowResizeProductImages ? 'contain' : 'cover';
	loading = true;

	constructor(
		private _router: Router,
		public _ref: DynamicDialogRef,
		private favoritesFacade: FavoritesFacade,
		private parametersFacade: ParametersFacade
	) {}

	private get parameters() {
		return this.parametersFacade.parameters;
	}

	openFavorites() {
		this._router.navigate(['/account/favorites']);
		this._ref.close();
	}
}
